var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDefaultCampaigns(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5996 5.60045H16.1997V4.80022H13.7998C13.7998 4.32024 13.4796 4 12.9996 4C12.5196 4 12.1994 4.32024 12.1994 4.80022H9.79948V5.60045H7.39957C6.91959 5.60045 6.6001 5.91994 6.6001 6.39993V19.1997C6.6001 19.6797 6.92034 19.9999 7.40032 19.9999H18.5996C19.0796 19.9999 19.3999 19.6797 19.3999 19.1997L19.3991 6.39993C19.3991 5.91994 19.0796 5.60045 18.5996 5.60045H18.5996ZM17.7994 18.3994H8.1998V7.20013H9.79948V8.00036H16.199L16.1997 7.20013H17.7994L17.7994 18.3994Z",
    fill: "#A8ADB2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.80005 10.4004H16.1995V12.0001H9.80005V10.4004Z",
    fill: "#A8ADB2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.80005 13.5996H16.1995V15.1993H9.80005V13.5996Z",
    fill: "#A8ADB2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultCampaigns);
export default __webpack_public_path__ + "static/media/defaultCampaigns.97b610e5b0a9dc971d90ebcd5ba094b4.svg";
export { ForwardRef as ReactComponent };